import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { DirectivesModule } from '@shared/directives/directives.module';
import { TagsComponent } from './tags.component';
import { ViewTagsComponent } from './view-tags.component';
import { L10nTranslationModule } from 'angular-l10n';
import { TranslationModule } from '@miq/utils';
import { TagClipboardKeyboardDirective } from '@shared/components/clipboard/tag-clipboard-keyboard.directive';

@NgModule({
  imports: [
    CommonModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    ReactiveFormsModule,
    DirectivesModule,
    L10nTranslationModule,
    TranslationModule,
    TagClipboardKeyboardDirective,
  ],
  exports: [TagsComponent],
  declarations: [TagsComponent, ViewTagsComponent],
  providers: [],
})
export class MiqTagsModule {}
